import { batchActionTypes } from '@Actions/batchActions';

const BatchReducers = (state = { }, action) => {
  switch (action.type) {
  case batchActionTypes.GET_BATCHES.LOADING: {
    const { getBatchesLoading } = action;
    return {
      ...state,
      getBatchesLoading,
    };
  }
  case batchActionTypes.GET_BATCHES.SUCCESS: {
    const { batches } = action;
    return {
      ...state,
      batches,
    };
  }
  case batchActionTypes.CREATE_BATCH.LOADING: {
    const { createBatchLoading } = action;
    return {
      ...state,
      createBatchLoading,
    };
  }
  case batchActionTypes.GET_RESERVATIONS.LOADING: {
    const { getReservationsLoading } = action;
    return {
      ...state,
      getReservationsLoading,
    };
  }
  case batchActionTypes.GET_RESERVATIONS.SUCCESS: {
    const { reservations } = action;
    return {
      ...state,
      reservations,
    };
  }
  default: {
    return state;
  }
  }
};

export default BatchReducers;
